<template>
  <div v-if="data" id="func-53-listagem">
    <FuncionalidadeHeader
      :titulo="titulo"/>

    <div class="func-actions">
      <div>
        <dashItem
          v-if="!permitirNovaConsulta"
          :svg="'icon_boleto_calendar.svg'"
          :title="'Nova Consulta'"
          :link="{ path: '/53/novo', query:{ step: 1, permiteAgendarTeleconsulta: this.configuracoes.permiteAgendarTeleconsulta, permiteAgendarPresencial: this.configuracoes.permiteAgendarPresencial  }}"
          :color="estilo.aplicacao.corPrimariaAplicacao"
        />
        <dashItem
          :svg="'Dash_historico.svg'"
          :link="{ path: '/53/historico' }"
          :title="'Históricos'"
          :color="estilo.aplicacao.corPrimariaAplicacao"
        />
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="listagem" v-for="(periodo, i) in listaConsultasPorData" :key="i">
      <h3 class="listagem-title">{{periodo.title}}</h3>
      <listagemStatus
        :empty-message="periodo.message"
        :style="'--cor-primaria:' + estilo.aplicacao.corPrimariaAplicacao + '0A'"
        :listagem-data="periodo.data.slice(0,maxItens)"
        :columns="columns"
        :click-row="detalhe"
        :status-field="'status'">
      </listagemStatus>
    </div>
    <div style="padding-left: 20px">
      <el-button @click="$router.push({path: '/53/historico'})" class="btn-historico">Ver histórico <i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import ListagemStatus from '@/components/listagemColumn/ListagemStatus.vue'
import FuncionalidadeHeader from '@/components/FuncionalidadeHeader/FuncionalidadeHeader'
import DateDayNameItem from '@/components/listagemColumn/DateDayNameItem'
import HoraPeriodo from '@/components/listagemColumn/HoraPeriodo'
import MultiFieldItem from '@/components/listagemColumn/MultiFieldItem'
import LocalItem from '@/components/listagemColumn/LocalItem'
import AcoesItem from '@/components/listagemColumn/AcoesItem'
import DashItem from '@/components/dashboard/DashItem'
import CountDown from '@/components/listagemColumn/CountDown'
import { EnumCanalAtendimentoOrigem } from '@/constants/EnumCanalAtendimentoOrigem'
import ArrowButton from '@/components/listagemColumn/ArrowButton.vue'
import AcoesMinhasConsultas from '@/components/listagemColumn/AcoesMinhasConsultas.vue'
import ColunaIcone from '@/components/listagemColumn/ColunaIcone'

export default {
  data () {
    return {
      data: null,
      configuracoes: {
        permiteAgendarTeleconsulta: true,
        permiteAgendarPresencial: true
      }
    }
  },
  components: {
    ListagemStatus,
    FuncionalidadeHeader,
    DashItem
  },
  computed: {
    ...mapState('SetupApp', ['apiFuncionalidade', 'funcionalidade']),
    ...mapGetters('Login', ['user']),
    ...mapGetters('SetupApp', ['estilo', 'canalAtendimentoOrigem']),
    defineColunaAcao () {
      switch (this.canalAtendimentoOrigem) {
        case EnumCanalAtendimentoOrigem.MOSIA_DESK:
          return { component: AcoesItem, width: 'auto' }
        default:
          return { component: ArrowButton, width: '20px' }
      }
    },
    columns () {
      return [
        { field: 'dataHora', component: DateDayNameItem, width: '96px' },
        { field: 'dataHora', component: HoraPeriodo, width: '80px' },
        { field: ['especialidade', 'profissional', 'paciente', 'servico'], component: MultiFieldItem, width: 'auto', click: this.detalhe },
        { field: ['tipoAgenda', 'localAtendimento'], component: LocalItem, width: 'auto' },
        [
          { component: CountDown, field: ['dataHora', 'status'], width: 'auto' },
          { component: AcoesMinhasConsultas, width: 'auto' }
        ],
        { field: 'consultaConfirmada', component: ColunaIcone, width: '20px', noPadding: true },
        this.defineColunaAcao
      ]
    },
    titulo () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    maxItens () {
      return this.funcionalidade.parametros.quantidadeItensLista
    },
    listaConsultasPorData () {
      const today = new Date().toISOString().split('T')[0]
      const list = [
        { title: 'Consultas hoje', data: [] },
        { title: 'Próximas Consultas', data: [] },
        { title: 'Consultas anteriores', data: [] }
      ]
      this.data.forEach(el => {
        const isClosed = el.status && el.status.encerrado ? el.status.encerrado : false
        const data = el.dataHora.split(' ')
        if (isClosed) {
          list[2].data.push(el)
        } else {
          if (moment(today).isBefore(data[0])) {
            list[1].data.push(el)
          } else if (moment(today).isAfter(data[0])) {
            list[2].data.push(el)
          } else {
            list[0].data.push(el)
          }
        }
      })
      this.ordenarDataHora(list[0])
      this.ordenarDataHora(list[1])
      this.ordenarDataHora(list[2], 'desc')

      // eslint-disable-next-line no-unused-expressions
      list[0].data.length === 0 ? list[0].message = this.funcionalidade.parametros.textos.textoVazioNenhumaConsultaHoje : ''
      // eslint-disable-next-line no-unused-expressions
      list[1].data.length === 0 ? list[1].message = this.funcionalidade.parametros.textos.textoVazioProximasConsultas : ''

      return list
    },
    permitirNovaConsulta () {
      return (!this.funcionalidade.parametros.ativaAgendamentoConsultaPresencial &&
        !this.funcionalidade.parametros.ativaAgendamentoTeleconsulta &&
        !this.funcionalidade.parametros.ativaFaleComMedico) || (!this.configuracoes.permiteAgendarTeleconsulta && !this.configuracoes.permiteAgendarPresencial)
    }
  },
  methods: {
    detalhe (row) {
      this.$router.push({ path: '/53/detalhe', query: { consulta: row } })
    },
    ordenarDataHora (data, order = 'asc') {
      return data.data.sort((a, b) => {
        const dataHoraA = new Date(a.dataHora)
        const dataHoraB = new Date(b.dataHora)
        if (order === 'asc') {
          return dataHoraA - dataHoraB
        }
        return dataHoraB - dataHoraA
      })
    }
  },
  async created () {
    const range = this.funcionalidade.parametros.rangeDataListaConsultas
    const hoje = new Date()
    const dataInicial = new Date(hoje)
    dataInicial.setMonth(dataInicial.getMonth() - range)
    const dataFinal = new Date(hoje)
    dataFinal.setMonth(dataFinal.getMonth() + range)
    const formatarData = data =>
      data.toISOString().split('T')[0]

    let result = await this.apiFuncionalidade.listaConsultas({
      payload: {
        dataInicial: formatarData(dataInicial),
        dataFinal: formatarData(dataFinal)
      },
      loading: true,
      headers: {
        order: 'desc'
      } })

    this.data = result.data.agendas
    if (Object.keys(result.data.configuracoes).length > 0) {
      this.configuracoes = result.data.configuracoes
    }
  }
}
</script>
<style lang="less">
#func-53-listagem {
  .listagem {
    margin: 20px;
  }
  .listagem-title {
    font-family: 'Open Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    text-align: left;
    line-height: 22px;
    margin-bottom: 18px;
  }
  tr.el-table__row.status-row {
    height: 89px;
  }
  .listagem .el-table .el-table__body .el-table__row td {
    background-color: var(--cor-primaria)
  }
  .el-table__body, .el-table__footer, .el-table__header {
    table-layout: unset;
  }
  .el-table__empty-block {
    height: 0 !important;
  }
  .func-actions {
    padding: 22px 20px 25px;
  }
  .listagem-status .el-table .el-table__body .el-table__row td:nth-child(2) {
    border-right: 2px dotted #FFFFFF !important;
    padding: 0 0 0 12px;
  }
  .listagem-status .el-table .el-table__body .el-table__row td:nth-child(1) {
    padding: 0 0 0 9px;
  }
  .el-table__empty-block {
    display: none!important;
  }
}
</style>
